import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const SALUTATIONS = {
    h: 'meneer',
    m: 'mevrouw',
};
const formatSalutation = (salutation) => (salutation && SALUTATIONS[salutation]) || '';
/**
 * Formats "van de" to "Van de " (uppercase first letter, rest lower case + a space)
 * space is only added when surnamePrefix is not empty.
 * @param {string} [surnamePrefix] - Surname, for example "van der"
 * @returns {string}
 */
const formatSurnamePrefix = (surnamePrefix) => {
    const result = (surnamePrefix || '').trim();
    if (result) {
        return `${result[0].toUpperCase()}${result.substr(1).toLowerCase()} `;
    }
    return result;
};
/**
 * Formats a name including prefix (meneer De Jong, mevrouw Van der Berg)
 * @param {string} [props.salutation] - Either 'm' or 'h'
 * @param {string} [props.surnamePrefix] - For example "van de"
 * @param {string} props.surname - Last name
 * @returns {string}
 */
const formatName = ({ salutation, surnamePrefix, surname }) => `${formatSalutation(salutation)} ${formatSurnamePrefix(surnamePrefix)}${surname}`.trim();
const ThankYouTitle = ({ salutation, surnamePrefix, surname }) => {
    const name = formatName({ salutation, surnamePrefix, surname });
    return (_jsxs(_Fragment, { children: ["Bedankt ", _jsx("span", { "data-hj-suppress": true, children: name })] }));
};
export default ThankYouTitle;
